import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Én bil. vehicle er null når den ikke finnes eller brukeren ikke har tilgang.
export function useOrgVehicle(vehicleId) {
  const [state, setState] = useState({ vehicle: null, loading: Boolean(vehicleId) });

  useEffect(() => {
    if (!vehicleId) {
      setState({ vehicle: null, loading: false });
      return undefined;
    }
    setState(s => ({ ...s, loading: true }));
    return onSnapshot(
      doc(db, 'orgVehicles', vehicleId),
      snap => setState({ vehicle: snap.exists() ? { id: snap.id, ...snap.data() } : null, loading: false }),
      () => setState({ vehicle: null, loading: false }),
    );
  }, [vehicleId]);

  return state;
}
